import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { mainSelector } from '$store/main';
import { Button, Header, Placeholder } from '$uikit';
import { IcSuccess72, IcWait72 } from '$assets';
import { useTranslator } from '$hooks';
import { authSelector } from '$store/auth';
import { AuthRequired } from '$core/AuthRequired/AuthRequired';

export const SubscriptionActivated: FC = () => {
  const { hasSubscription } = useSelector(mainSelector);
  const { isLogged } = useSelector(authSelector);
  const t = useTranslator();

  const handleRefresh = useCallback(() => {
    location.reload();
  }, []);

  if (!isLogged) {
    return <AuthRequired />;
  }

  function renderContent() {
    if (hasSubscription) {
      return (
        <Placeholder
          centered
          title={t('subscription_success_title')}
          icon={<IcSuccess72 />}
          actions={
            <Button size="small" href="/feed">
              {t('go_to_home')}
            </Button>
          }
        >
          {t('subscription_success_caption')}
        </Placeholder>
      );
    }

    return (
      <Placeholder
        centered
        title={t('subscription_activated_title')}
        icon={<IcWait72 color="var(--tint-gold)" />}
        actions={
          <Button onClick={handleRefresh}>{t('subscription_activated_button')}</Button>
        }
      >
        {t('subscription_activated_caption')}
      </Placeholder>
    );
  }

  return (
    <>
      <Header showBackButton />
      {renderContent()}
    </>
  );
};
